import { render, staticRenderFns } from "./FrequencySettingsMail.vue?vue&type=template&id=2b5a486e"
import script from "./FrequencySettingsMail.vue?vue&type=script&lang=ts"
export * from "./FrequencySettingsMail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b5a486e')) {
      api.createRecord('2b5a486e', component.options)
    } else {
      api.reload('2b5a486e', component.options)
    }
    module.hot.accept("./FrequencySettingsMail.vue?vue&type=template&id=2b5a486e", function () {
      api.rerender('2b5a486e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frequency-documents/FrequencySettingsMail.vue"
export default component.exports